import { useEffect, useState } from 'react';
import { checkEnvironmentCameraSupport } from '../utils/cameraSupport';

/**
 * Probe for a rear (environment) camera when `enabled`.
 * While checking, `available` is false so Take photo stays inert (no file-picker fallback).
 */
export default function useEnvironmentCameraSupport(enabled = true) {
  const [state, setState] = useState({
    checking: Boolean(enabled),
    available: false,
    reason: null,
  });

  useEffect(() => {
    if (!enabled) {
      setState({ checking: false, available: false, reason: null });
      return undefined;
    }

    let cancelled = false;
    setState((prev) => ({ ...prev, checking: true }));

    checkEnvironmentCameraSupport().then((result) => {
      if (!cancelled) {
        setState({
          checking: false,
          available: result.available,
          reason: result.reason,
        });
      }
    });

    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return state;
}
